/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetPaymentUrl200ResponseData
 */
export interface GetPaymentUrl200ResponseData {
  /**
   * Ссылка на форму оплаты
   * @type {string}
   * @memberof GetPaymentUrl200ResponseData
   */
  paymentUrl: string
}

/**
 * Check if a given object implements the GetPaymentUrl200ResponseData interface.
 */
export function instanceOfGetPaymentUrl200ResponseData(
  value: object
): value is GetPaymentUrl200ResponseData {
  if (!('paymentUrl' in value) || value['paymentUrl'] === undefined)
    return false
  return true
}

export function GetPaymentUrl200ResponseDataFromJSON(
  json: any
): GetPaymentUrl200ResponseData {
  return GetPaymentUrl200ResponseDataFromJSONTyped(json, false)
}

export function GetPaymentUrl200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPaymentUrl200ResponseData {
  if (json == null) {
    return json
  }
  return {
    paymentUrl: json['paymentUrl'],
  }
}

export function GetPaymentUrl200ResponseDataToJSON(
  value?: GetPaymentUrl200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    paymentUrl: value['paymentUrl'],
  }
}
